import CustomerDashboard from 'components/customer/Dashboard.vue'
import CustomerEdit from 'components/customer/Edit.vue';
import CustomerCreate from 'components/customer/Create.vue';
import Dashboard from 'components/dashboard/Dashboard.vue'
import ProjectDashboard from 'components/project/ProjectDashboard.vue'
import ProjectCreate from 'components/project/ProjectCreate.vue'
import ProjectEdit from 'components/project/ProjectEdit.vue'
import InvoiceDashboard from 'components/invoice/InvoiceDashboard.vue'
import InvoiceCreate from 'components/invoice/InvoiceCreate.vue'
import InvoiceEdit from 'components/invoice/InvoiceEdit.vue'
import InvoiceViewer from 'components/invoice/InvoiceViewer.vue'
import DocumentDashboard from 'components/documents/DocumentDashboard.vue'
import MainAppContainer from 'components/app/MainAppContainer.vue'
import NotFound from 'components/error/NotFound.vue'
import Login from 'components/auth/Login.vue'
import Signup from 'components/auth/Singup'
import VueRouter from "vue-router"
import firebase from 'firebase/app'

const routes = [

    {
      path: '/',
      redirect: '/app'
    },
    {
        path: '/app',
        component: MainAppContainer,
        meta: {
            requiresAuth: true
        },

        children: [

            {
                path: 'dashboard',
                component: Dashboard,
                name: 'Dashboard'
            },
            {
                path: 'customer',
                component: CustomerDashboard,
                name: 'CustomerDashboard'
            },
            {
                path: 'customer/add',
                name: 'CustomerAdd',
                component: CustomerCreate
            },
            {
                path: 'customer/edit/:slug',
                name: 'CustomerEdit',
                component: CustomerEdit
            },
            {
                path: 'invoice',
                component: InvoiceDashboard,
                name: 'InvoiceDashboard'
            },
            {
                path: 'invoice/add',
                name: 'InvoiceAdd',
                component: InvoiceCreate
            },
            {
                path: 'invoice/edit/:id',
                name: 'InvoiceEdit',
                component: InvoiceEdit
            },
            {
                path: 'invoice/view/:id',
                name: 'InvoiceViewer',
                component: InvoiceViewer
            },
            {
                path: 'project',
                component: ProjectDashboard,
                name: 'ProjectDashboard'
            },
            {
                path: 'project/add',
                name: 'ProjectAdd',
                component: ProjectCreate
            },
            {
                path: 'project/edit/:slug',
                name: 'ProjectEdit',
                component: ProjectEdit
            },
            {
                path: 'document',
                component: DocumentDashboard,
                name: 'DocumentDashboard'
            }
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/signup',
        component: Signup,
        name: 'Signup'
    },
    {
        path: '*',
        name: 'NotFound',
        component: NotFound
    }
];



const router = new VueRouter({
    routes,
    mode: 'history'
});


router.beforeEach((to, from, next) => {

    if (to.matched.some(r => r.meta.requiresAuth)) {

        if (firebase.auth().currentUser) {
            next();
        } else {
            next({name: 'Login'});
        }
    } else {
        next();
    }
});


export default router;